export const PRIMARY         = '#1075BA';
export const CONTAINER_COLOR = '#8b4fcc';
export const COUNTDOWN_COLOR = '#0ea5e9';

// Minimal ELEMENT_TYPES — only defaultData is used in preview mode
export const ELEMENT_TYPES = {
  container: {
    defaultData: { type: 'container', orientation: 'column', children: [], style: { padding: '5px', background: 'transparent', borderRadius: '8px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch', alignSelf: 'stretch' } },
  },
  text: {
    defaultData: { type: 'text', content: 'Click to edit text', style: { fontSize: '16px', color: '#1a1a2e', fontWeight: '400' } },
  },
  button: {
    defaultData: { type: 'button', label: 'Click Me', href: '#', style: { background: PRIMARY, color: '#fff', borderRadius: '8px', padding: '10px 24px', fontSize: '14px', fontWeight: '700' } },
  },
  image: {
    defaultData: { type: 'image', src: '', alt: '', style: { width: '100%', height: 'auto', borderRadius: '4px', display: 'block' } },
  },
};